import { render } from "./SimpleModal.vue?vue&type=template&id=68ab12ab"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"

import "./SimpleModal.vue?vue&type=style&index=0&id=68ab12ab&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__